import { render, staticRenderFns } from "./SettingPannel.vue?vue&type=template&id=62599cda&scoped=true"
import script from "./SettingPannel.vue?vue&type=script&lang=js"
export * from "./SettingPannel.vue?vue&type=script&lang=js"
import style0 from "./SettingPannel.vue?vue&type=style&index=0&id=62599cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62599cda",
  null
  
)

export default component.exports